/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { TaxDocumentDto } from "./TaxDocumentDto";
import approvalType = TaxDocumentDto.approvalType;

export type TaxClientRequest = {
    accountantId?: string;
    avatar?: string;
    color?: string;
    companyId?: string;
    name?: string;
    note?: string;
    period?: TaxClientRequest.period;
    unitPath?: string;
    userId?: string;
    valid?: boolean;
    registrationEmail?: boolean;
    approvalType?: approvalType;
    useCentre?: boolean;
    useActivity?: boolean;
    useContract?: boolean;
    useAsDefault?: boolean;
};

export namespace TaxClientRequest {
    export enum period {
        MONTH = "MONTH",
        QUARTER = "QUARTER",
    }
}
